import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getLocalizations({ commit }, {
        paginate = '',
        query = '',
        shouldSavedInStore = true
    } = {}) {
        commit('GET_LOCALIZATIONS_REQUEST')

        return axios
            .get(`/outdoors/outdoor-localizations${paginate}${query}`)
            .then(response => {
                if (shouldSavedInStore) commit('GET_LOCALIZATIONS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_LOCALIZATIONS_FAILURE')
                handleApiError(error, 'Pobranie lokalizacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getLocalization(context, id) {
        return axios
            .get(`/outdoors/outdoor-localizations/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do lokalizacji ${id} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    createLocalization({ commit }, localizationData) {
        return axios
            .post('/outdoors/outdoor-localizations', localizationData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Lokalizacja została dodana.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie lokalizacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateLocalization({ commit }, localizationData) {
        return axios
            .put(`/outdoors/outdoor-localizations/${localizationData.id}`, localizationData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Lokalizacja została zedytowana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis lokalizacji nie powiódł się.')

                return Promise.reject(error)
            })
    },
    deleteLocalization({ commit }, localizationId) {
        return axios
            .delete(`/outdoors/outdoor-localizations/${localizationId}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Lokalizacja została usunięta.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie lokalizacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setLocalizationFilters({ commit }, filters) {
        commit('SET_LOCALIZATION_FILTERS', filters)
    },
    clearLocalizationFilters({ commit }) {
        commit('CLEAR_LOCALIZATION_FILTERS')
    }
}